import React from "react"
import { Outlet } from "react-router-dom"

const PublicContainer = () => (
  <Outlet />
)

export default PublicContainer